
import { nanoid } from '@reduxjs/toolkit';
import axios from 'axios' ;
import { useQuery ,useMutation, useQueryClient} from '@tanstack/react-query' ; 

import { axios_equipement_findbyIdlead } from '../axios/axios_equipement';
import { store } from "./redux";
import { queryClient } from './queryClient';


import {axios_jeresilie_getCompagniesMotifs }from '../axios/axios_jeresilie';
import { axios_devis_finddevis } from '../axios/axios_devis';
import { axios_memory_gethorodatagebyid , axios_memory_writehorodatage , axios_memory_getnotebyid,
        axios_memory_writenote} from '../axios/axios_memory';
import { axios_notifs_getnotifs } from '../axios/axios_notifs';
import { axios_tickets_gettickets } from '../axios/axios_tickets';
import { axios_contrats_getcontratsbyemail , axios_contrats_deletecontrat } from '../axios/axios_contrats';
import { axios_email_getclientemails , axios_email_getallemails , axios_email_getgestionmails , axios_email_postmarkmails  } from '../axios/axios_email';
import { axios_files_getclientdocs } from '../axios/axios_files';
import { axios_gestion_getcommissions } from '../axios/axios_gestion';

import { axios_cabinets_getusers,axios_cabinets_getcabinetequipes ,axios_cabinets_getequipesmanagers} from '../axios/axios_cabinets';
import { axios_courtier_getall , axios_courtier_getinfoscourtier} from '../axios/axios_courtier';
import { axios_cabinetscompagnies_getdatasparametrage  } from '../axios/axios_cabinetscompagnies';
import { axios_users_userauthenticate } from '../axios/axios_users';
import { axios_compagnies_allcompagniestarifs } from '../axios/axios_compagnies';

import { axios_gestion_getcommerciaux , axios_gestion_searchleadsfxnumeros } from '../axios/axios_gestion';
import { axios_contrats_getall } from '../axios/axios_contrats';
import {axios_clients_findnontraites ,  axios_clients_findclients  , axios_clients_findcomclients} from '../axios/axios_clients';


const useEnableQuerryAfterClients= ()=>{
  const ecran = store.getState().display.ecran ; 
  const {  isLoading }= useComclients() ;
  return (ecran==='dashboard' && !isLoading ) || ecran!=='dashboard' ;
}



// DEV
const useEnableQuerryAfterEcran= ()=>{
  const lead = store.getState().lead.leadactu ;
  return lead.id ? true : false  ;
}


// TICKETS
 const queryTickets = async()=>{
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  if(!user?.postmail) { return  [] }
  let response = await axios_tickets_gettickets(user.postmail) ;
    return response?.data || []
} 

export const useTickets = ()=>useQuery({ queryKey: ['tickets'], queryFn: queryTickets ,    staleTime: Infinity , enabled: useEnableQuerryAfterClients() ,placeholderData: [] });

export const useAddTicket = () => {
  const queryClient= useQueryClient();
  return useMutation({mutationFn:  (ticket)=>{  return  ticket},
                      onSuccess:(ticket)=>{ queryClient.setQueryData(['tickets'],[...queryClient.getQueryData(['tickets']),ticket])   },})
}

export const addTicket= (ticket)=>{
  const tickets = queryClient.getQueryData(['tickets'])  ?? [];
  queryClient.setQueryData(['tickets'],[...tickets,ticket])
}



// DOCUMENTS 
const queryDocuments= async(id_lead)=>{
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  let response = await axios_files_getclientdocs(id_lead,user?.courtier)
  return response.data
} 

export const useDocuments = (id_lead)=>useQuery({ queryKey: ['documents',id_lead], queryFn:async () => await queryDocuments(id_lead) ,    staleTime: 10*60*1000  });

export const useAddDocuments = (id_lead) => {
  const queryDocuments= useQueryClient();
  return useMutation({
    mutationFn:  (docu)=>{  return  docu},
    onSuccess:(docu)=>{ 
      const docactus = queryDocuments.getQueryData(['documents',id_lead])  ?? [];
      queryDocuments.setQueryData(['documents',id_lead],[...docactus,docu])
    }
  })
}

export const addDocument = (id_lead,docu)=>{
  const docactus = queryClient.getQueryData(['documents',id_lead])  ?? [];
  queryClient.setQueryData(['documents',id_lead],[...docactus,docu])
}

// HISTORY
const queryHistories= async(id_lead)=>{ 
  let response = await axios_memory_gethorodatagebyid(id_lead) ;
  return response.data  || []
} 

export const useHistories = (id_lead)=>{  return   useQuery({ queryKey: ['histories',id_lead], queryFn:async () =>queryHistories(id_lead) ,    staleTime: 10*60*1000  }); }
  
export const addEltHistory = async(id_lead,type,description)=>{
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);                              
  await axios_memory_writehorodatage({type,description,id:nanoid(),id_lead ,'courtier':user?.['nomdomaine'],'commercial':user?.['nom']})
  queryClient.invalidateQueries({ queryKey: ['histories',id_lead]})     
}



// EMAILS  POUR UN CLIENT
const queryListmails= async(userpostmail,leadactuemail)=>{
  let response =  await axios_email_getclientemails(userpostmail,leadactuemail)
    return response.data
} 

export const useListmails = (userpostmail,leadactuemail)=>useQuery({ queryKey: ['clientmails',userpostmail,leadactuemail], queryFn: () =>queryListmails(userpostmail,leadactuemail) ,    staleTime: 10*60*1000 , enabled: useEnableQuerryAfterEcran() });


// EMAILS   POUR LA BOITE MAIL
const queryAllmails= async()=>{
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  let response =  await axios_email_getallemails(user.postmail) ;
  return response.data
} 

export const useAllmails = ()=>useQuery({ queryKey: ['listmails'], queryFn: () =>queryAllmails() ,    staleTime: Infinity  , enabled: useEnableQuerryAfterClients() });


// EMAILS   POUR LA BOITE MAIL  GESTION
const queryGestionmails= async()=>{
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  if(!localStorage.getItem('token') ||    !user?.courtier ){return []}
  let response =  await axios_email_getgestionmails() ; 
  return response.data
} 

export const useGestionmails = ()=>useQuery({ queryKey: ['listgestionmails'], queryFn: () =>queryGestionmails() ,    staleTime: Infinity , enabled: useEnableQuerryAfterClients()  });


// NOTIFICATIONS
const queryNotifs = async()=>{
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  if(!user?.postmail) { return  [] }
  let response = await axios_notifs_getnotifs(user.postmail);
    return response?.data|| []
} 

export const useNotifs = ()=>useQuery({ queryKey: ['notifs'], queryFn: queryNotifs ,    staleTime: Infinity  ,enabled: useEnableQuerryAfterClients() });



export const useAddNotif = () => {
  const queryClient= useQueryClient();
  return useMutation({mutationFn:  (notif)=>{  return  notif},
                      onSuccess:(notif)=>{ queryClient.setQueryData(['notifs'],[...queryClient.getQueryData(['notifs']),notif])},})

}



export const addnotif = (notif) => {
  const notifsactus = queryClient.getQueryData(['notifs'])  ?? []
  queryClient.setQueryData(['notifs'],[...notifsactus,notif]) 
}




// NOTES
const queryNotes= async(id_lead)=>{
  let response = await axios_memory_getnotebyid(id_lead);
  return response.data
} 

export const useNotes = (id_lead)=>{return   useQuery({ queryKey: ['notes',id_lead], queryFn:async () =>queryNotes(id_lead) ,    staleTime: 10*60*1000  });}
  
export const addOneNote= async(id_lead,note)=>{
  const lead = store.getState().lead.leadactu ;
  const newnote = { 'id_lead':lead.id ,id_note:nanoid() , 'note': note?.replace(/\n/g,'<br />'),date_note: new Date()}
  const notesactus = queryClient.getQueryData(['notes',lead.id])  ?? [];
  await axios_memory_writenote({id:id_lead,  note})
  queryClient.setQueryData(['notes',lead.id],[...notesactus,newnote])
}

// CONTRATSBYEMAIL
const queryContrats= async(email,courtier)=>{
  let response = await axios_contrats_getcontratsbyemail(email,courtier) ;
  return response.data
}      

export const useContrats = (email,courtier)=>{ 
       return  useQuery({ queryKey:['contrats',email,courtier],queryFn:async() =>queryContrats(email,courtier),staleTime: 10*60*1000}); }
  
export const deleteContrat = (indexe)=>{
    const lead = store.getState().lead.leadactu ;
    const contratsactus =  queryClient.getQueryData(['contrats',lead.email,lead.courtier])  ?? [];
    const newcontrats = contratsactus.filter(x=>x.indexe!==indexe);
    axios_contrats_deletecontrat(indexe)
    queryClient.setQueryData(['contrats',lead.email,lead.courtier],[...newcontrats]) ;
}


// SIGNASSUR
const querySignassur= async(id)=>{
  if(!id){return {}}
  let response = await axios.post(`/signassur/searchsignassurbyid`,{id},{headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
  return response.data
}      

export const useSignassur= (id)=>{  ; 
   return  useQuery({ queryKey: ['signassur',id], queryFn:async () =>querySignassur(id), staleTime: 10*60*1000});
}




// YOUSIGN
// const queryYousign= async(id)=>{
//   if(!id){return {}}
//   let response = await axios.post(`/yousign/searchyousignbyid`,{id},{headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
//   return response.data
// }      

// export const useYousign = (id)=>{  ; 
//    return  useQuery({ queryKey: ['yousign',id], queryFn:async () =>queryYousign(id), staleTime: 10*60*1000});
// }


// DEVIS
const queryDevis= async(id_lead)=>{
  let response = await axios_devis_finddevis(id_lead) ;
  return response.data
}      

export const useDevis = (id_lead)=>{  ; 
   return  useQuery({ queryKey: ['devis',id_lead], queryFn:async () =>queryDevis(id_lead), staleTime: 10*60*1000});
}
  
// FIC
    //DEV AXIOS
const queryFic= async(id_fic)=>{
  let response = await axios.post(`/conseil/getconseilbyid/`,{'id':id_fic},{headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
  return response.data || [] ; 
}      

export const useFic = (id_fic)=>{ 
   return  useQuery({ queryKey: ['fic',id_fic], queryFn:async () =>queryFic(id_fic), staleTime: 10*60*1000});
}
    
// RESIL 
const queryResil= async(id_resil)=>{
  let response = await axios.post(`/resiliation/getresiliationbyid`,{'id':id_resil},{headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
  return response.data
}      

export const useResil = (id_resil)=>{ 
   return  useQuery({ queryKey: ['resil',id_resil], queryFn:async () =>queryResil(id_resil), staleTime: 10*60*1000});
}


// EQUIPEMENTS
const queryEquipements= async(id_lead)=>{
  const response = await axios_equipement_findbyIdlead(id_lead) ; 
  return response.data
}      

export const useEquipements = (id_lead)=>{ 
       return  useQuery({ queryKey:['equipement',id_lead],queryFn:async() =>queryEquipements(id_lead),staleTime: 10*60*1000}); 
}
  



// COMCLIENTS 
const queryComclients= async()=>{
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  if(!user.courtier){return {}};
  const response = await axios_clients_findcomclients() ; 
  return response.data
}      


export const useComclients = ()=>{ 
       return  useQuery({ queryKey:['comclients'],queryFn:async() =>queryComclients(),staleTime: 20*60*1000}); 
}
  


// MENTOR
// ,refetchInterval: 1000*60*1000

// COURTIERS
const queryCourtiers= async()=>{  
  // ICI SUPERADMIN
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  if(user?.role !=="SUPERADMIN"){return []};
  const response =await axios_courtier_getall() ;
  return response?.data || [] ; 
} 

export const useCourtiers = ()=>useQuery({ queryKey: ['courtiers'], queryFn:async () =>queryCourtiers() ,    staleTime: Infinity  });


// COURTIER
const queryCourtier= async()=>{  
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  const response =await axios_courtier_getinfoscourtier(user?.['courtier']) ;
  return response?.data || []
} 

export const useCourtier = ()=>useQuery({ queryKey: ['courtier'], queryFn:async () =>queryCourtier() , staleTime: 10*60*1000  , cacheTime:0  , structuralSharing: false, });

// EQUIPES
const queryEquipes= async(courtier)=>{  
    const response =await axios_cabinets_getcabinetequipes(courtier) ; 
    return  response.data 
} 

export const useEquipes = (courtier)=>useQuery({ queryKey: ['equipes', courtier], queryFn:async () =>await queryEquipes(courtier) ,    staleTime: Infinity });

// EQUIPES_MANAGERS
const queryEquipesManagers= async(listeidmanagers)=>{  if(!listeidmanagers) {return []}; 
  const response =await axios_cabinets_getequipesmanagers(listeidmanagers) ;
  return response.data?.reduce( (accumulator, {id_equipe,id_manager}) => {
                                      const s =  accumulator[id_equipe];
                                      if(s){ s.add(id_manager) ;}
                                      else{accumulator[id_equipe] = new Set([id_manager])}
                                        return accumulator
                                  }, {}) ;
} 

export const useEquipesManagers = (listeidmanagers)=>useQuery({ queryKey: ['equipes_managers', listeidmanagers], queryFn:async () =>queryEquipesManagers(listeidmanagers) ,    staleTime: Infinity  });

//USERS CABINETS
const queryUsers= async()=>{  
    let response = await axios_cabinets_getusers();
    return response.data
} 

export const useUsers= (courtier)=>useQuery({ queryKey: ['users',courtier], queryFn: () =>queryUsers() ,    staleTime: Infinity  });


// USER
const queryUser= async()=>{  
  let user  ;
    if(!localStorage.getItem('token') )  {  return  { 'authenticate' : false}   ;}
    try{const  response =  await axios_users_userauthenticate()
        user =  {...response.data , 'authenticate' : true,} ; 
        response.data.telephone && localStorage.setItem('teltwilio', response.data.telephone);
        window.usetifulTags = {userId:response.data.id,
                                segment:response.data.courtier,
                                firstName:response.data.firstname,
                                lastName:response.data.lastname,
                                role:response.data.roles?.join(',')}                                 
        }catch(err){user =  { 'authenticate' : false}   }
        return user
} 
export const useUser = (token)=>useQuery({ queryKey: ['user',token], queryFn: () =>queryUser() ,    staleTime: Infinity    });


// DATAS COURTIER COMPAGNIES
const queryDatasCourtierCompagnies= async()=>{  
  const response =await axios_cabinetscompagnies_getdatasparametrage() ;
  return response?.data || []
} 

export const useDatasCourtierCompagnies = ()=>useQuery({ queryKey: ['datascourtiercompagnies'],queryFn:async () =>queryDatasCourtierCompagnies(), staleTime:Infinity});




// DATAS COURTIER COMPAGNIES
const queryAllCompagniesTarifs= async()=>{  
  const response =await axios_compagnies_allcompagniestarifs() ;
  return response?.data || []
} 

export const useAllCompagniesTarifs = ()=>useQuery({ queryKey: ['allcompagniestarifs'],queryFn:async () =>queryAllCompagniesTarifs(), staleTime:Infinity});


// DEV CONTRATS DU COURTIER
const queryAllContrats= async(debut,fin)=>{

  if(!debut){return []}
  let response = await axios_contrats_getall({debut,fin}) ;
  return response.data
}      

export const useAllContrats = (debut,fin)=>{ 
       return  useQuery({ queryKey:['allcontrats',debut,fin],queryFn:async() =>queryAllContrats(debut,fin),staleTime: 10*60*1000}); }
  


// GESTION LEADS FXNUMEROS PAR DATE....
const queryLeadsAndFxNumeros= async(debut,fin,typedate)=>{  
  let response = await axios_gestion_searchleadsfxnumeros({debut,fin,typedate})  ;
  return {'leads':response?.data?.leads || [] , 'fauxnumeros':response?.data?.fauxnumeros || []  }
} 


export const useLeadsAndFxNumeros= (debut,fin,typedate)=>{ 

  return useQuery({ queryKey: ['leadsandfauxnumeros',debut,fin,typedate],
                  queryFn:async () =>await queryLeadsAndFxNumeros(debut,fin,typedate) ,  
                  staleTime: 10*60*1000   });
}





const queryCommerciaux= async()=>{  
  let response = await axios_gestion_getcommerciaux() ;
  return response?.data || []
} 

export const useCommerciaux= ()=>useQuery({ queryKey: ['commerciaux'], queryFn:async () =>queryCommerciaux() ,    staleTime: Infinity  });

// DATASJERESILIE

const queryCompagniesMotifs= async()=>{ 
  let response = await axios_jeresilie_getCompagniesMotifs() ;
  return response.data  || { liste_motifs:[], liste_compagnies:[] }
} 

export const useCompagniesMotifs = ()=>{  return   useQuery({ queryKey: ['jeresilie'], queryFn:async () =>queryCompagniesMotifs() ,    staleTime: Infinity }); }
  


// DATASJERESILIE

const queryCommissions= async()=>{ 
  let response = await axios_gestion_getcommissions() ;
  return response.data  ||  [] ; 
}

export const useCommissions = ()=>{  return   useQuery({ queryKey: ['commissions'], queryFn:async () =>queryCommissions() ,    staleTime: Infinity }); }
  

// postmarkmails   axios_email_postmarkmails


const queryPostmarkmails = async()=>{
  const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
  if(!localStorage.getItem('token') ||    !user?.courtier ){return []}
  let response =  await axios_email_postmarkmails() ; 
  return response.data
} 

export const usePostmarkmails = ()=>useQuery({ queryKey: ['postmarkmails'], queryFn: () =>queryPostmarkmails(), staleTime: Infinity });




